import Section from 'components/base/Section';
import EComCustomerProductsTable from 'components/tables/EComCustomerProductsTable';

const CustomerProducts = () => {
  return (
    <div className="pt-5 mb-9">
      <Section small className="py-0">
        <h2 className="mb-5">My Products</h2>
        <EComCustomerProductsTable />
      </Section>
    </div>
  );
};

export default CustomerProducts;
